/* eslint-disable camelcase */

export enum AnalyticEvent {
  Login = 'login',
  Purchase = 'purchase',
  ChangeCity = 'change_city',
  BeginCheckout = 'begin_checkout',
  ViewCart = 'view_cart',
  ViewItem = 'view_item',
  SelectItem = 'select_item',
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  CartBookConfirmDoneBookings = 'cart_book_confirm_done_bookings'
}

export enum PackageFullness {
  Full = 'full',
  Portion = 'portion',
  FullPortion = 'full_portion'
}

export enum ItemListName {
  TopSearch = 'top_search',
  YouBrowsedMain = 'you_browsed_main',
  YouBrowsedItem = 'you_browsed_item',
  Category = 'category',
  SpeedSearch = 'speed_search',
  FullSearch = 'full_search',
  Tradename = 'tradename',
  TradenameWithTheCity = 'tradename_with_the_city',
  FullAnalogues = 'full_analogues',
  TherapeuticEffect = 'therapeutic_effect',
  AnaloguesInOtherForms = 'analogues_in_other_forms',
  // Some default value that can be used if there are no specific analytics list name
  Default = 'default'
}

type Affiliation = 'login' | 'not login';

export type EcommerceItem = {
  item_name: string;
  item_id: string;
  price: number;
  item_brand: string;
  item_category: string;
  quantity?: number;
  item_list_name?: ItemListName;
  index?: string;
};

export type Ecommerce = {
  transaction_id?: string;
  affiliation?: Affiliation;
  value?: number;
  currency?: string;
  coupon?: string;
  items: EcommerceItem[];
};

export type AnalyticDataEntity = {
  event: AnalyticEvent;
  city: string;
  pharmacy?: string;
  ecommerce?: Ecommerce;
  package?: PackageFullness;
  transaction_id?: string;
  affiliation?: Affiliation;
};

type EcommerceEmptyEntity = {
  ecommerce: null;
};

export type AnalyticLoginEntity = {
  event: AnalyticEvent.Login;
  uid: string;
};

export type DataLayer = (
  | AnalyticDataEntity
  | EcommerceEmptyEntity
  | AnalyticLoginEntity
)[];
